import type { ReactNode } from 'react';

export type RefreshedPhonebookValidationState = {
  validatedPhonebookValues: Set<string>;
  inFlightPhonebookValidationValue: string | null;
  phonebookValidationError: ReactNode;
  isPhonebookValidated: boolean;
  shouldAutoValidate: boolean;
};



export const buildRefreshedPhonebookValidationState = (
  selectedPhonebookValue: string | null | undefined
): RefreshedPhonebookValidationState => ({
  validatedPhonebookValues: new Set<string>(),
  inFlightPhonebookValidationValue: null,
  phonebookValidationError: '',
  isPhonebookValidated: false,
  shouldAutoValidate: String(selectedPhonebookValue ?? '').trim().length > 0,
});
